// Storage key for localStorage
export const STORAGE_KEY = "revenue-kpi-table-settings"

// Version for table settings - increment this when adding/removing tables
export const SETTINGS_VERSION = 8

// Default table settings
export const DEFAULT_TABLE_SETTINGS = {
  version: SETTINGS_VERSION,
  order: [
    "adSpend",
    "mer",
    "croWebMerch",
    "searchKPIs",
    "brandValue",
    "brandValueBreakdown",
    "digitalEngagement",
    "brand",
    "gaRevenue",
    "shopifyRevenue",
    "shopifyCustomer",
    "shopifyEcommRevenue",
    "shopifyRetailRevenue",
    "amazonRevenue",
    "wholesale",
    "shopifyContribution",
    "revenueBreakdown",
    "metaAdsReachImpressions",
    "metaAdsAudienceSegments",
    "traffic",
    "averageOrderValues",
    "totalBusinessRevenue",
  ],
  expanded: {
    adSpend: true,
    mer: true,
    metaAdsReachImpressions: false,
    metaAdsAudienceSegments: false,
    traffic: false,
    averageOrderValues: false,
    totalBusinessRevenue: true,
    croWebMerch: false,
    searchKPIs: false,
    brand: false,
    gaRevenue: true,
    shopifyRevenue: true,
    shopifyCustomer: false,
    shopifyEcommRevenue: false,
    shopifyRetailRevenue: false,
    amazonRevenue: false,
    wholesale: false,
    shopifyContribution: false,
    revenueBreakdown: true,
    brandValue: true,
    brandValueBreakdown: true,
    digitalEngagement: false,
  },
}

// Table configuration interface
export interface TableConfig {
  data: Record<string, string | number | undefined>[]
  title: string
  showTotals: boolean
  scrollRef: React.RefObject<HTMLDivElement>
  tableKey: string
  available: boolean
  missingConnectors: { name: string; connected: boolean }[]
  isLoading?: boolean
  wowMarginalLabel?: string
  marginalMetrics?: string[]
  granularity?: import("~/ui-rtk/constants/charts").AggregationType
}

// Per-chart height preferences (the Metrics Explorer chart and tables-view
// group charts). Stored OUTSIDE the versioned table-settings blob above: a
// SETTINGS_VERSION bump wipes the user's table order/expanded state, and these
// entries are purely additive.
export const CHART_HEIGHT_STORAGE_KEY = "revenue-kpi-chart-heights"
/** Matches the legacy fixed `h-96` chart wrapper (384px). */
export const DEFAULT_CHART_HEIGHT = 384
export const MIN_CHART_HEIGHT = 240
export const MAX_CHART_HEIGHT = 1200
